import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

import SplashView from './views/splash'
import LoginView from './views/login'
import AdminView from './views/admin'
import DevView from './views/dev'

import * as MutationTypes from './store/mutation-types';

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'splash',
      component: SplashView,
      meta: {
        background: 'login'
      },
    },

    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        background: 'login'
      },
    },

    // Admin
    {
      path: '/admin',
      name: 'admin-page',
      component: AdminView,
      meta: {
        loginRequired: true,
        appSegment: 'admin',
      },
      children: [
        {
          path: ':page',
        },
        {
          path: ':page/:action/:id',
        }
      ]
    },

    // Dev
    {
      path: '/dev',
      name: 'dev-page',
      component: DevView,
      meta: {
        appSegment: 'dev',
      },
      children: [
        {
          path: ':page',
        },
        {
          path: ':page/:action/:id',
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = store.getters.getCurrentUser;

  if (to.matched.some(record => record.meta.loginRequired)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!currentUser) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })

      return;
    }
  }

  if (to.meta.background) {
    store.commit(MutationTypes.SET_CURRENT_BACKGROUND, to.meta.background);
  }

  next() // make sure to always call next()!
})

export default router;